import styled from 'styled-components';

const getColor = (status: string) => {
  switch (status) {
    case 'refund':
    case 'credit':
      return '#16D679';
    case 'adjustment':
      return '#FFAE34';
    case 'charge':
    case 'payment':
    case 'purchase':
    case 'subscription':
      return '#FF2F2F';
    default:
      return '#858DBD';
  }
};

export type TStyledTextProps = {
  type: string;
};

export const StyledText = styled.p<TStyledTextProps>`
  color: ${(props) => getColor(props.type)};
  font-weight: 500;
`;
